// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3TcF6","actionsCol":"EnrolledClinics_actionsCol__18tro"};